// Shared loan-report engine — raw HTTP transport for the per-discipline
// monthly report ledger on the loan detail page (Insurance / UCC tabs).
// Hooks in @/hooks/portfolioAdmin/useLoanReports wrap these with
// TanStack Query.

import { api, API_BASE } from "../client";

export type LoanReportDiscipline = "Insurance" | "Ucc" | "Qa" | "FinancialReporting";
// "PendingReview" exists only on the FinancialReporting discipline
// (PreparerReviewer two-signature ladder).
export type LoanReportStatus = "Draft" | "PendingReview" | "Certified" | "Filed";

export interface LoanReportDto {
  id: string;
  /** Null for portfolio-level Financial Reporting instances. */
  loanId: string | null;
  discipline: LoanReportDiscipline;
  periodStart: string;
  periodEnd: string;
  status: LoanReportStatus;
  preparedByUserName: string | null;
  preparedAt: string;
  certifiedByUserName: string | null;
  certifiedAt: string | null;
  filedDocumentId: string | null;
  filedAt: string | null;
  supersedesId: string | null;
  /** "FR-M4" … — set only on the FinancialReporting discipline. */
  seriesCode: string | null;
}

export interface GenerateLoanReportRequest {
  discipline: LoanReportDiscipline;
  periodStart: string;
  periodEnd: string;
}

export const loanReportsApi = {
  list: (loanId: string, discipline: LoanReportDiscipline) =>
    api.get<LoanReportDto[]>(`/portfolio-admin/loans/${loanId}/reports`, {
      discipline,
    }),
  generate: (loanId: string, body: GenerateLoanReportRequest) =>
    api.post<LoanReportDto>(
      `/portfolio-admin/loans/${loanId}/reports/generate`,
      body,
    ),
  certify: (reportId: string) =>
    api.post<LoanReportDto>(`/portfolio-admin/loan-reports/${reportId}/certify`),
  file: (reportId: string) =>
    api.post<LoanReportDto>(`/portfolio-admin/loan-reports/${reportId}/file`),
  /** Raw PDF endpoint (not enveloped) — used as an iframe src. */
  previewUrl: (reportId: string) =>
    `${API_BASE}/portfolio-admin/loan-reports/${reportId}/preview`,
};
